import React from 'react';
import PropTypes from 'prop-types';
import { Button } from '@telus-uds/components-web';

import { useLocalizedStringsContext } from '../../../context/LocalizedStringsContext';
import ModalCustom from '../../../design/shared/modal';
import { ModalBox } from '../css';
import TypeAhead from './typeAhead';

const OrderAssignee = ({
  assignee,
  users,
  onAssigneeChange,
  onClickSave,
  setAssigneeModal
}) => {
  const localizedStrings = useLocalizedStringsContext();
  const {
    assigneeSRTModal: { addAssigneeLabel },
    ORDERS: { unassigned, assigneModelHeader },
    formButtons: { saveButtonLabel }
  } = localizedStrings;
  const closeModal = () => setAssigneeModal(false);
  const onClick = () => {
    onClickSave(false);
    closeModal();
  };

  return (
    <ModalCustom
      open="true"
      setOpen={closeModal}
      header={assigneModelHeader}
      customStyles={{ height: '450px' }}
    >
      <TypeAhead
        label={addAssigneeLabel}
        onChange={onAssigneeChange}
        options={users}
        selected={assignee}
        placeholder={unassigned}
      />
      <ModalBox>
        <Button onPress={onClick}>{saveButtonLabel}</Button>
      </ModalBox>
    </ModalCustom>
  );
};

OrderAssignee.propTypes = {
  setAssigneeModal: PropTypes.func.isRequired,
  onAssigneeChange: PropTypes.func.isRequired,
  onClickSave: PropTypes.func.isRequired,
  assignee: PropTypes.arrayOf(PropTypes.string).isRequired,
  users: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number
    })
  ).isRequired
};

export default OrderAssignee;
